/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

export default {
    cint,
    pmt,
    cost,
    numPayments
};

function cint(P, r, n, t, c) {
    // Compound Interest

    // P:	Principal value
    // r:	interest rate expressed as a decimal
    // n:	number of compounding periods per year
    // t:	total time in years
    // c:	periodic contribution amount

    // returns principal plus compound interest

    var total,
        z = Number(1 + r / n);

    total = (P * Math.pow(z, n * t)) + (c * ((Math.pow(z, n * t + 1) - z) / (z - 1)));

    if (isNaN(total)) {
        return 0;
    } else {
        return total;
    }

    //return ( P * Math.pow(z, n*t) ) + ( c * ((Math.pow(z, n*t+1) - z)/(z-1)) );
}

function pmt(P, r, n, t) {
    // Loan Payments

    // P:	Principal borrowed
    // r:	APR expressed as a decimal
    // n:	number of payments per year
    // t:	total term of loan in years
    var total;

    r /= n; // Interest rate applied per billing cycle

    total = P * (r + r / (Math.pow(1 + r, n * t) - 1));

    if (isNaN(total)) {
        return 0;
    } else {
        return total;
    }

    //return P * (r+r/(Math.pow(1+r, n*t)-1));
}

function cost(P, r, n, t) {
    // Total Cost of Loan

    // P:	Principal borrowed
    // r:	APR expressed as a decimal
    // n:	number of payments per year
    // t:	total term of loan in years

    var total = pmt(P, r, n, t) * n * t;

    if (isNaN(total)) {
        return 0;
    } else {
        return total;
    }
}

function numPayments(P, r, mp) {
    // Number of payments

    // P:	Principal borrowed
    // r:	APR expressed as a decimal
    // mp: Monthy payment

    var i = Number(r / 12);

    return -Math.log(1 - (i * P) / mp) / Math.log(1 + i);
}


// WEBPACK FOOTER //
// ./src/calculators/utils.js